import { SubmissionError } from 'redux-form';

import { API_BASE_URL } from '../config';
import { normalizeResponseErrors } from './utils';
import axios from 'axios'

export const registerUser = user => dispatch => {
    return fetch(`${ API_BASE_URL }/users`, {
        method: 'POST',
        headers: {
            'content-type': 'application/json'
        },
        body: JSON.stringify(user)
    })
        .then(res => normalizeResponseErrors(res))
        .then(res => {
            res.json()
        })
        .catch(err => {
            const { reason, message, location } = err;
            if (reason === 'ValidationError') {
                return Promise.reject(
                    new SubmissionError({
                        [location]: message
                    })
                );
            }
        });
}

export const LIST_OTHER_USER_DATA ='LIST_OTHER_USER_DATA'
export const listOtherUserData = userObj => ({
    type: LIST_OTHER_USER_DATA,
    userObj
})

export const getUserData = userId => dispatch => {
    return axios
            .get(`${API_BASE_URL}/users/${userId}`)
            .then(res => {
                dispatch(listOtherUserData(res.data))
            })
}


// WEBPACK FOOTER //
// ./src/actions/users.js